import { SearchOutlined, PlusOutlined, PrinterOutlined, FileExcelOutlined, DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Drawer, Input, Space, Table } from 'antd';
import { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { TableStat } from "./TableStat";
import css from './MainTable.module.css';
import { ExportSheet } from "react-xlsx-sheet";
import * as XLSX from 'xlsx';
import { useReactToPrint } from "react-to-print";

export function MainTable({ pdata, pcolumns, defkey, add, onDelete, onEdit, edit, setEd, view, viewBtn, statData, pageTitle, title, xwidth, onView, edw, adw, addBtnDisable }) {
    const headingTitle = pageTitle || title;
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const [open, setOpen] = useState(false);
    const [openedit, setOpenedit] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    const showDrawerEdit = () => {
        setOpenedit(true);
    };
    const onCloseEdit = () => {
        setOpenedit(false);
        setEd({});
    };

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 12,
                    borderRadius: 'var(--radius-md)',
                    backgroundColor: 'var(--bg-card)',
                    boxShadow: 'var(--shadow-lg)',
                    border: '1px solid var(--border)',
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder="Qidirish..."
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    className={css.searchInput}
                    style={{
                        marginBottom: 12,
                        width: '100%',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Qidirish
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Tozalash
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? 'var(--primary)' : 'var(--text-muted)',
                    transition: 'color var(--transition-fast)',
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : false,
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: 'var(--warning-light)',
                        padding: '2px 4px',
                        borderRadius: '4px',
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    let columns = pcolumns?.map((item) => {
        return Object.assign({
            sorter: (a, b) => {
                if (a[item.dataIndex] > b[item.dataIndex]) return 1;
                if (a[item.dataIndex] === b[item.dataIndex]) return 0;
                if (a[item.dataIndex] < b[item.dataIndex]) return -1;
            },
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps(item.dataIndex),
        }, item);
    });

    columns?.push({
        title: 'Amallar',
        dataIndex: 'tools',
        key: 'tools',
        fixed: 'right',
        width: 120,
        align: 'center',
        render: (_, rec) => (
            <Space size="small">
                {viewBtn && (
                    <Button
                        type="text"
                        icon={<EyeOutlined />}
                        onClick={e => onView(e, rec)}
                        style={{ color: 'var(--info)' }}
                    />
                )}
                {edit && (
                    <Button
                        type="text"
                        icon={<EditOutlined />}
                        onClick={e => { onEdit(rec); setOpenedit(true); }}
                        style={{ color: 'var(--primary)' }}
                    />
                )}
                <Button
                    type="text"
                    icon={<DeleteOutlined />}
                    onClick={e => onDelete(e, rec)}
                    style={{ color: 'var(--danger)' }}
                />
            </Space>
        ),
    });

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <>
            <TableStat statData={statData} />

            <Drawer
                title="Ma'lumot qo'shish"
                width={adw || 760}
                size={'large'}
                placement="right"
                onClose={onClose}
                open={open}
                className="animate-slide-in-right"
            >
                {add}
            </Drawer>

            <Drawer
                title="Ma'lumotni tahrirlash"
                width={edw || 760}
                size={'large'}
                placement="right"
                onClose={onCloseEdit}
                open={openedit}
                className="animate-slide-in-right"
            >
                {edit}
            </Drawer>

            <div className={css.heading}>
                <h2>{headingTitle}</h2>
                <Space>
                    <Button
                        onClick={handlePrint}
                        icon={<PrinterOutlined />}
                        style={{
                            backgroundColor: 'var(--text-muted)',
                            borderColor: 'var(--text-muted)',
                        }}
                    />
                    <ExportSheet
                        header={pcolumns}
                        fileName={headingTitle}
                        dataSource={pdata}
                        xlsx={XLSX}
                    >
                        <Button
                            type="primary"
                            icon={<FileExcelOutlined />}
                            style={{
                                backgroundColor: 'var(--success)',
                                borderColor: 'var(--success)',
                            }}
                        />
                    </ExportSheet>
                    {!addBtnDisable && (
                        <Button
                            type="primary"
                            onClick={showDrawer}
                            icon={<PlusOutlined />}
                        >
                            Qo'shish
                        </Button>
                    )}
                </Space>
            </div>

            <Table
                scroll={{ x: xwidth || 1300 }}
                size='small'
                rowKey={defkey}
                ref={componentRef}
                columns={columns}
                dataSource={pdata}
                pagination={{
                    pageSize: 20,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
                }}
            />
        </>
    );
}
